import React, { useEffect, useRef } from "react";
import "./course.css";
import ReactPlayer from "react-player";
import { Container } from "react-bootstrap";
import profile from "../../assets/image/icon/profile.jpeg";
import { ReactComponent as Play } from "../../assets/image/icon/play.svg";
import { useNavigate, useParams } from "react-router-dom";
import { useState } from "react";
import { useAuthContext } from "../../AuthContextAPI";
import { api } from "../../api/api";
import { getTemporaryUrl, loadRazorpay } from "../../Utils";
import CommonTabs from "../../Components/CommonTabs/CommonTabs";
import { List } from "lucide-react";
import CustomPopup from "../../Components/CustomPopup/CustomPopup";
import Plan, { SubscriptionPlan } from "../../Components/Plan/Plan";

import play_btn from "../../assets/image/play_btn.png";

const CoursesDetails = () => {
  const [course, setCourse] = useState();
  const [currentVideo, setCurrentVideo] = useState({
    videoUrl: ``,
    title: "",
  });
  const [status, setStatus] = useState("");

  const { currUserData } = useAuthContext();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [showPlan, setShowPlan] = useState(false);
  const [activeVideoId, setActiveVideoId] = useState(null);
  const parentAccordions = [
    { id: "videoCourses", title: "Video Courses" },
    { id: "documents", title: "Documents" }, // Add this new accordion
  ];
  const courseId = useParams();

  const tabs = [
    {
      id: "about",
      label: "About",
      title: course?.title || "About the Course",
      htmlContent: course?.about || "", // full HTML
    },
    {
      id: "Importance",
      label: "Importance",
      title: course?.title || "",
      htmlContent: course?.importance || "",
    },
    {
      id: "LearningOutcomes",
      label: "Learning Outcomes",
      title: course?.title || "",
      htmlContent: course?.learning || "",
    },
  ];

  // console.log(course?.image, "course?.imagecourse?.imagecourse?.imagecourse?.image");

  // Fetch Courses
  const getCourseData = async () => {
    setIsLoading(true);

    if (currUserData) {
      let res = await api(
        `api/v1/student/getAllCoursesBasedOnUser?page=1&limit=10`,
        "",
        "get",
        currUserData.token,
        ""
      );

      if (res?.success) {
        const filteredData = res?.data.find(
          (item) => item._id === courseId.name
        );
        //const filteredData = res?.data.filter((item) => item._id === courseId);

        console.log(filteredData, "filteredData");
        setCourse(filteredData);
      }
    } else {
      let res = await api(
        `api/v1/student/getliveCourses?page=1&limit=10`,
        "",
        "get",
        "",
        ""
      );

      if (res?.success) {
        const filteredData = res?.data.find(
          (item) => item._id === courseId.name
        );
        //const filteredData = res?.data.filter((item) => item._id === courseId);

        console.log(filteredData, "filteredData live");
        setCourse(filteredData);
      }
    }
    setIsLoading(false);
  };

  useEffect(() => {
    getCourseData();
  }, []);
  console.log(currentVideo, "currentVideocurrentVideo");

  const handlePurchase = async (planNumber, courseId) => {
    if (!currUserData?.token) {
      navigate("/login");
      return;
    }

    setShowPlan(false);
    try {
      // Load Razorpay dynamically
      const Razorpay = await loadRazorpay();
      if (!Razorpay) throw new Error("Failed to load Razorpay SDK");

      // Step 1: Create Order
      const payload = { courseId, subscriptionType: planNumber };
      const res = await api(
        "api/v1/payment/createOrder",
        payload,
        "post",
        currUserData?.token,
        ""
      );
      if (!res?.status)
        throw new Error(res?.response || "Order creation failed");

      const orderData = res.data;
      console.log(orderData, "Order Created");

      // Step 2: Configure Razorpay
      const options = {
        key: orderData.key,
        amount: orderData.amount * 100, // Convert to paise
        currency: orderData.currency,
        name: "Your Learning Platform",
        description: "Course Purchase",
        order_id: orderData.orderId,
        handler: async (response) => {
          try {
            // Step 3: Verify Payment
            const verificationRes = await api(
              `api/v1/payment/verifyPayment/${orderData.paymentId}`,
              response,
              "post",
              currUserData?.token,
              ""
            );

            console.log(verificationRes, "Payment Verified");

            if (!verificationRes?.status)
              throw new Error(
                verificationRes?.response || "Payment verification failed"
              );

            setStatus("✅ Payment successful! Course enrolled.");
          } catch (error) {
            setStatus("❌ Verification failed: " + error.message);
          }
        },
        prefill: {
          name: currUserData?.name || "Test User",
          email: currUserData?.email || "test@example.com",
          contact: currUserData?.phone || "9999999999",
        },
        theme: { color: "#4CAF50" },
      };

      // Step 4: Open Razorpay Checkout
      const rzp = new Razorpay(options);
      rzp.open();
    } catch (error) {
      console.error("Payment Error:", error.message);
      setStatus("❌ Error: " + error.message);
    }
  };

  // const handelCurrentVideo = async (video , index) => {
  //   const newVideo = await getTemporaryUrl(video.videoUrl);
  //   console.log(video._id , video, "videovideovideo ssss");
  //   setCurrentVideo({ ...video, videoUrl: newVideo });

  // };
  const handelCurrentVideo = async (video) => {
    const newVideo = await getTemporaryUrl(video.videoUrl);
    setCurrentVideo({ ...video, videoUrl: newVideo });
    setActiveVideoId(video._id); // ✅ Keep track of selected video

    // Scroll to the video player
    setTimeout(() => {
      videoPlayerRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 100);
  };

  // console.log(currentVideo, "course");
  console.log(course, "vvvvv");

  const handleSubscription = (planNumber) => {
    if (course && course._id) {
      handlePurchase(planNumber, course?._id);
    }
  };

  const videoPlayerRef = useRef(null);
  return (
    <>
      <div className="course_single pt_150">
        <Container>
          <div className="row">
            <div className="col-md-8">
              <div className="left_side">
                {currentVideo?.videoUrl ? (
                  <div className="player" ref={videoPlayerRef}>
                    <ReactPlayer
                      url={currentVideo.videoUrl}
                      key={currentVideo.videoUrl} // force remount on URL change
                      // light={course?.image}
                      playing={true}
                      controls
                      className="video_player"
                    />
                  </div>
                ) : (
                  <div
                    className="videp_thumbline"
                    onClick={() => {
                      if (course?.content?.[0]?.videos?.[0]) {
                        handelCurrentVideo(course.content[0].videos[0]);
                      }
                    }}
                  >
                    <div className="play_btn">
                      <img src={play_btn} alt="Play button" />
                    </div>
                    <img src={course?.image} alt="Course thumbnail" />
                  </div>
                )}

                {/* <div className="player">
                 
                  <ReactPlayer
                    url={currentVideo.videoUrl}
                    light={course?.image}
                    playing={true}
                    controls
                    className="video_player"
                  />
                </div> */}
                <div className="course_heading">
                  <h2>{currentVideo?.title}</h2>
                  {/* <ul>
                    <li>
                      <i class="far fa-flag"></i>
                    </li>
                    <li>
                      <i class="far fa-calendar-alt"></i>
                    </li>
                    <li>
                      <i class="fas fa-share-alt"></i>
                    </li>
                  </ul> */}
                </div>
                <ul className="course_detail">
                  <li className="course_author">
                    {/* <img src={profile} alt="" /> */}
                    <p>
                      <p className="text-capitalize">
                        {course?.instructor?.name}
                      </p>
                      <span>Instructor</span>
                    </p>
                  </li>
                  <li className="course_review">
                    <i class="fas fa-star"></i> 4.8 (Review 2K)
                  </li>
                  {/* <li className="course_video">
                    <i class="fas fa-play-circle"></i> 120 Video Course
                  </li>
                  <li className="course_student">
                    <i class="fas fa-user-graduate"></i> 15k Students
                  </li> */}
                </ul>

                <CommonTabs tabs={tabs} defaultActive={0} />

                {/* this code for backup */}
                <div className="courses__details-content d-none">
                  <ul class="nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link  active"
                        id="about-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#about-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="about-tab-pane"
                        aria-selected="true"
                      >
                        About
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link "
                        id="Importance-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#Importance-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="Importance-tab-pane"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        Importance
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link "
                        id="LearningOutcomes-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#LearningOutcomes-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="LearningOutcomes-tab-pane"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        LearningOutcomes
                      </button>
                    </li>
                    <li class="nav-item" role="presentation">
                      <button
                        class="nav-link "
                        id="reviews-tab"
                        data-bs-toggle="tab"
                        data-bs-target="#reviews-tab-pane"
                        type="button"
                        role="tab"
                        aria-controls="reviews-tab-pane"
                        aria-selected="false"
                        tabindex="-1"
                      >
                        reviews
                      </button>
                    </li>
                  </ul>
                  <div class="tab-content" id="myTabContent">
                    <div
                      class="tab-pane fade show active"
                      id="about-tab-pane"
                      role="tabpanel"
                      aria-labelledby="about-tab"
                      tabindex="0"
                    >
                      <div class="courses_about">
                        <p>
                          Donec sed erat ut magna suscipit mattis. Aliquam erat
                          volutpat. Morbi in orci risus. Donec pretium fringilla
                          blandit. Etiam ut accumsan leo. Aliquam id mi quam.
                          Vivamus dictum ut erat nec congue. Etiam facilisis
                          lacus ut arcu vulputate, non pellentesque sem
                          convallis. Proin tempus sapien nisl, nec varius risus
                          tristique a. Etiam ligula lacus, ultricies at cursus
                          id, fringilla nec nulla.
                        </p>
                        <p>
                          Fusce pretium laoreet diam a mollis. In finibus purus
                          sed tortor fringilla, eu luctus lorem sodales.Ut
                          dignissim ante ac augue vulputate tristique. Mauris
                          venenatis tincidunt nibh, sit amet fringilla augue
                          malesuada a. Mauris a nunc congue, viverra lectus sed,
                          imperdiet quam. Aenean tempor sem sed lorem ultricies
                          lacinia.
                        </p>

                        <p>
                          Sed sit amet tortor nibh. Donec condimentum posuere
                          nunc, et hendrerit sapien dictum ut. Aliquam congue
                          non purus eu suscipit. Integer eu dui tortor. Donec ut
                          dolor vitae ipsum ultrices semper. Morbi imperdiet
                          dictum urna nec blandit. Curabitur interdum diam ut
                          porta vulputate. Fusce ultrices efficitur lectus et
                          ornare. Morbi vulputate condimentum metus eu viverra.
                          Integer iaculis volutpat lobortis.
                        </p>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="Importance-tab-pane"
                      role="tabpanel"
                      aria-labelledby="Importance-tab"
                      tabindex="0"
                    >
                      <div class="courses_Importance">
                        <h3 class="title">Importance</h3>
                        <p></p>
                      </div>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="LearningOutcomes-tab-pane"
                      role="tabpanel"
                      aria-labelledby="LearningOutcomes-tab"
                      tabindex="0"
                    >
                      <>
                        <div class="courses_LearningOutcomes">
                          LearningOutcomes
                        </div>
                      </>
                    </div>
                    <div
                      class="tab-pane fade"
                      id="reviews-tab-pane"
                      role="tabpanel"
                      aria-labelledby="reviews-tab"
                      tabindex="0"
                    >
                      <div class="courses__rating-wrap">
                        <h2 class="title">Reviews</h2>
                        <div class="course-rate">
                          <div class="course-rate__summary">
                            <div class="course-rate__summary-value">5.0</div>
                            <div class="course-rate__summary-stars">
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                              <i class="fas fa-star"></i>
                            </div>
                            <div class="course-rate__summary-text">
                              1 Ratings
                            </div>
                          </div>
                          <div class="course-rate__details">
                            <div class="course-rate__details-row">
                              <div class="course-rate__details-row-star">
                                5<i class="fas fa-star"></i>
                              </div>
                              <div class="course-rate__details-row-value">
                                <div class="rating-gray"></div>
                                <div
                                  class="rating"
                                  style={{ width: "100%" }}
                                  title="100%"
                                ></div>
                                <span class="rating-count">1</span>
                              </div>
                            </div>
                            <div class="course-rate__details-row">
                              <div class="course-rate__details-row-star">
                                4<i class="fas fa-star"></i>
                              </div>
                              <div class="course-rate__details-row-value">
                                <div class="rating-gray"></div>
                                <div
                                  style={{ width: "0%" }}
                                  class="rating"
                                  title="0%"
                                ></div>
                                <span class="rating-count">0</span>
                              </div>
                            </div>
                            <div class="course-rate__details-row">
                              <div class="course-rate__details-row-star">
                                3<i class="fas fa-star"></i>
                              </div>
                              <div class="course-rate__details-row-value">
                                <div class="rating-gray"></div>
                                <div
                                  class="rating"
                                  style={{ width: "0%" }}
                                  title="0%"
                                ></div>
                                <span class="rating-count">0</span>
                              </div>
                            </div>
                            <div class="course-rate__details-row">
                              <div class="course-rate__details-row-star">
                                2<i class="fas fa-star"></i>
                              </div>
                              <div class="course-rate__details-row-value">
                                <div class="rating-gray"></div>
                                <div
                                  class="rating"
                                  style={{ width: "0%" }}
                                  title="0%"
                                ></div>
                                <span class="rating-count">0</span>
                              </div>
                            </div>
                            <div class="course-rate__details-row">
                              <div class="course-rate__details-row-star">
                                1<i class="fas fa-star"></i>
                              </div>
                              <div class="course-rate__details-row-value">
                                <div class="rating-gray"></div>
                                <div
                                  class="rating"
                                  style={{ width: "0%" }}
                                  title="0%"
                                ></div>
                                <span class="rating-count">0</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <>
                          <div class="course-review-head">
                            <div class="review-author-thumb">
                              <img
                                src="https://skillgro.websolutionus.com/uploads/website-images/frontend-avatar.png"
                                alt="img"
                              />
                            </div>

                            <div class="review-author-content">
                              <div class="author-name">
                                <h5 class="name">
                                  Cain Buck
                                  <span>23 Jun, 2024</span>
                                </h5>
                                <div class="author-rating">
                                  {/* {item.rating.map((star)=>{
                                        return (
                                          <>
                                            {" "}
                                            <i class="fas fa-star"></i>
                                          </>
                                        );
                                      })} */}
                                  {/* {Array.from({ length: totalStars }, (v, i) => (
                              <span
                                key={i}
                                style={{
                                  color: i < item.rating ? "gold" : "gray",
                                }}
                              >
                                ★
                              </span>
                            ))} */}
                                  <span
                                    style={{
                                      color: "gold",
                                    }}
                                  >
                                    ★
                                  </span>
                                </div>
                              </div>
                              <p>Good course loved it a lot</p>
                            </div>
                          </div>
                        </>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Side - Parent Accordion */}

            <div className="col-md-4">
              <div className="right_side">
                <div className="accordion" id="parentAccordion">
                  {/* Video Courses Accordion */}
                  <div className="accordion-item">
                    <h2 className="accordion-header" id="videoHeading">
                      <button
                        className="accordion-button"
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#videoCollapse"
                        aria-expanded="true"
                        aria-controls="videoCollapse"
                      >
                        Video Courses
                      </button>
                    </h2>
                    <div
                      id="videoCollapse"
                      className="accordion-collapse collapse show"
                      aria-labelledby="videoHeading"
                      data-bs-parent="#parentAccordion"
                    >
                      <div className="accordion-body">
                        <div className="accordion" id="videoChildAccordion">
                          {course?.content?.map(
                            (module, moduleIndex) =>
                              module.videos.length > 0 && (
                                <div
                                  className="accordion-item"
                                  key={`video-module-${moduleIndex}`}
                                >
                                  <h2
                                    className="accordion-header"
                                    id={`videoModuleHeading-${moduleIndex}`}
                                  >
                                    <button
                                      className="accordion-button"
                                      type="button"
                                      data-bs-toggle="collapse"
                                      data-bs-target={`#videoModuleCollapse-${moduleIndex}`}
                                      aria-expanded={
                                        moduleIndex === 0 ? "true" : "false"
                                      }
                                      aria-controls={`videoModuleCollapse-${moduleIndex}`}
                                    >
                                      {module.moduleTitle}
                                    </button>
                                  </h2>
                                  <div
                                    id={`videoModuleCollapse-${moduleIndex}`}
                                    className={`accordion-collapse collapse ${
                                      moduleIndex === 0 ? "show" : ""
                                    }`}
                                    aria-labelledby={`videoModuleHeading-${moduleIndex}`}
                                    data-bs-parent="#videoChildAccordion"
                                  >
                                    <div className="accordion-body p-0">
                                      <ul className="course_videos">
                                        {module.videos.map(
                                          (video, videoIndex) => {
                                            const isLocked =
                                              !course?.coursePurchased &&
                                              !video?.isFreeAccess;
                                            return (
                                              <>
                                                <li
                                                  key={video._id}
                                                  className={`video-item ${
                                                    isLocked
                                                      ? "disabled-video"
                                                      : ""
                                                  } ${
                                                    activeVideoId === video._id
                                                      ? "active"
                                                      : ""
                                                  }`}
                                                  onClick={() =>
                                                    !isLocked &&
                                                    handelCurrentVideo(video)
                                                  }
                                                >
                                                  <Play
                                                    width={8}
                                                    height={8}
                                                    className="play-icon"
                                                  />
                                                  <span className="ps-3 d-flex justify-content-between video_link w-100">
                                                    <span>{video?.title}</span>
                                                    <span>
                                                      {video?.duration}
                                                    </span>
                                                  </span>
                                                </li>
                                              </>
                                            );
                                          }
                                        )}
                                        {module.documents.map((document) => {
                                          const isLocked =
                                            !course?.coursePurchased &&
                                            !document?.isFreeAccess;
                                          return (
                                            <li
                                              key={document._id}
                                              className={`document-item ${
                                                isLocked
                                                  ? "disabled-document"
                                                  : ""
                                              }`}
                                            >
                                              <a
                                                href={
                                                  isLocked
                                                    ? "#"
                                                    : document.docUrl
                                                }
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="d-flex justify-content-between w-100"
                                                onClick={(e) =>
                                                  isLocked && e.preventDefault()
                                                }
                                              >
                                                <span>
                                                  <i className="far fa-file-alt me-2"></i>
                                                  {document.title}
                                                </span>
                                                <span className="text-muted">
                                                  {document.docUrl
                                                    ?.split(".")
                                                    .pop()
                                                    .toUpperCase()}
                                                </span>
                                              </a>
                                            </li>
                                          );
                                        })}
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              )
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Purchase button - only show if course not purchased */}
                </div>

                {course && !course?.coursePurchased ? (
                  <>
                    <button
                      className="download_button"
                      onClick={() => setShowPlan(true)}
                    >
                      {/* Download Material */}
                      Purchase Now
                    </button>
                  </>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
        </Container>
      </div>
      <CustomPopup size={"xl"} show={showPlan} close={setShowPlan} title="">
        <div className="row justify-content-center gx-3 p-5">
          {course?.monthlyPrice && course?.monthlyDescription && (
            <div className="col-md-6 col-lg-4">
              <SubscriptionPlan
                planNumber={1}
                name={"Monthly"}
                price={course?.monthlyPrice}
                description={course?.monthlyDescription}
                handleSubscription={handleSubscription}
              />
            </div>
          )}

          {course?.yearlyPrice && course?.yearlyDescription && (
            <div className="col-md-6 col-lg-4">
              <SubscriptionPlan
                planNumber={3}
                name={"Yearly"}
                price={course?.yearlyPrice}
                description={course?.yearlyDescription}
                handleSubscription={handleSubscription}
              />
            </div>
          )}
          {course?.quaterlyPrice && course?.quaterlyDescription && (
            <div className="col-md-6 col-lg-4">
              <SubscriptionPlan
                planNumber={2}
                name={"Quaterly"}
                price={course?.quaterlyPrice}
                description={course?.quaterlyDescription}
                handleSubscription={handleSubscription}
              />
            </div>
          )}
        </div>
      </CustomPopup>
    </>
  );
};

export default CoursesDetails;
